import { IDogsProfile } from 'models/common.model'
import { WOOFZ_COACHING } from 'nove8/constants/root-constants'
import { STEPS_MAP } from 'nove8/constants/steps-map'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'

export const getWoofzCoachingSteps = (dogsProfile: IDogsProfile[] | null) => {
  const shouldSliceSteps = !dogsProfile || (dogsProfile?.length ?? 0) < 2

  useZustandSessionStore.setState({
    isSlicedCoachingSteps: shouldSliceSteps ?? false,
  })

  return shouldSliceSteps
    ? STEPS_MAP[WOOFZ_COACHING].slice(1)
    : STEPS_MAP[WOOFZ_COACHING]
}
